import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IThemes } from 'src/app/core/themes/themes.model';
import { ApiService } from 'src/app/services/api.service';
import { tap, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SuccessRequestComponent } from 'src/app/shared/success-request/success-request.component';
import { FailRequestComponent } from 'src/app/shared/fail-request/fail-request.component';
import { throwError } from 'rxjs';
import { UserActionService } from 'src/app/core/users/users.action';

@Component({
  selector: 'app-new-theme',
  templateUrl: './new-theme.component.html',
  styleUrls: ['./new-theme.component.scss']
})
export class NewThemeComponent {
  theme_current: IThemes = {
    id: null,
    name: {
      it: '',
      sl: '',
      en: ''
    }
  };

  current_lang = 'it';
  loading = false;

  constructor(private titleService: Title,
              private route: Router,
              private apiservice: ApiService,
              private userAction: UserActionService,
              private translate: TranslateService,
              public dialog: MatDialog) {
    this.translate.setDefaultLang('it');
    if (this.translate.currentLang) {
      this.translate.use(this.translate.currentLang);
    } else {
      this.translate.use('it');
    }
    this.translate.get('breadcrumb.new_theme').subscribe((res: string) => {
      this.titleService.setTitle(res + ' - PRIMIS');
    });
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('breadcrumb.new_theme').subscribe((res: string) => {
        this.titleService.setTitle(res + ' - PRIMIS');
      });
    });
  }

  routerFunction(path_to_new_page) {
    this.route.navigate([path_to_new_page]);
  }

  saveTheme() {
    this.loading = true;
    this.apiservice.newTheme(this.theme_current).pipe(
      tap((x: any) => {
        if (x && !x.error) {
          this.userAction.addOrUpdateUser(x);
          this.loading = false;
          const dialogRef = this.dialog.open(SuccessRequestComponent, {
            width: '450px'
          });
          dialogRef.afterClosed().subscribe(() => this.routerFunction('/lista-percorsi-tematici'));
        }
      }),
      catchError(error => {
        this.loading = false;
        this.dialog.open(FailRequestComponent, {
          width: '450px'
        });
        return throwError(error);
      })
    ).subscribe();
  }

  saveButtonDisabled() {
    const isValid = !!this.theme_current.name.it && !!this.theme_current.name.sl && !!this.theme_current.name.sl;
    return !isValid;
  }
}
